<template>
  <div
    class="desktop-view page"
  >
    <div class="sensata-splash-wrapper" @click="goToAdmin()">
      <SensataSplash></SensataSplash>
      <el-button
        class="log-out-button delay-entry delay-like-crazy"
        round
        type="danger"
        @click="logOut()"
        v-if="loggedIn"
      >Log out</el-button>
    </div>

    <div class="admin-content-wrapper unselectable delay-entry">
      <el-row class="log-in-button-wrapper">
        <el-button
          class="delay-entry delay-like-crazy log-in-button"
          round
          type="danger"
          @click="logIn()"
          v-if="!loggedIn"
        >Log in</el-button>
      </el-row>
      <section class="user-section delay-entry delay-like-crazy">
        <div v-if="loggedIn && !sid" key="user-email" class="delay-entry">
          <p>Hola, <strong>{{username}}</strong>!</p>
        </div>
        <div class="selected-survey-header delay-entry" key="user-selected-survey" v-if="loggedIn && sid">
          <h5><strong>Survey:</strong> {{getSurveyName(sid)}}</h5>
          <div class="close-icon-wrapper clear-selected-survey-wrapper delay-entry" @click="clearSelectedSurvey()" v-if="sid">
            <Icons class="icon" icon="close" size="48" color="#5d2466"></Icons>
          </div>
        </div>

        <div class="sid-selector delay-entry" v-if="!sid" key="user-selector">
          <el-select size="large" v-model="sid" placeholder="Selecciona una encuesta" v-if="sidList || mongoDBChartsList || mongoDashList">
            <el-option
              v-for="i in allMongoDashKeys"
              :key="`mongoDashList_${i}`"
              :label="`[dash] ${getSurveyName(i)}`"
              :value="i">
            </el-option>
            <el-option
              v-for="(survey, i) in sidList"
              :key="survey"
              :label="getSurveyName(survey)"
              :value="survey">
            </el-option>
          </el-select>
        </div>

        <div class="actions-wrapper" v-if="sid && mongoDBChartsList && mongoDBChartsList[sid]">
          <div
            class="action-wrapper delay-entry delay-like-crazy log-in-button"
            @click="$router.push(`/charts/${sid}`)"
            type="warning"
          >
            <div class="profile-image-wrapper">
              <div
                class="avatar"
                :style="{backgroundImage: `url(${publicPath}/img/bermuda-downloading.png)`}"
              ></div>
            </div>
            <p>Charts</p>
          </div>
        </div>
        <div class="actions-wrapper" v-if="sid && mongoDashList && mongoDashList[sid]">
          <div
            class="action-wrapper delay-entry delay-like-crazy log-in-button"
            @click="$router.push(`/mongo-dash/${sid}`)"
            type="warning"
          >
            <div class="profile-image-wrapper">
              <div
                class="avatar"
                :style="{backgroundImage: `url(${publicPath}/img/arabica-1.png)`}"
              ></div>
            </div>
            <p>Dashboard</p>
          </div>
        </div>
        <div class="actions-wrapper" v-if="sid && sidList && sidList.includes(sid)">
          <div
            class="action-wrapper delay-entry delay-like-crazy log-in-button"
            @click="$router.push(`/survey/${sid}/play`)"
            type="warning"
          >
            <div class="profile-image-wrapper">
              <div
                class="avatar"
                :style="{backgroundImage: `url(${publicPath}/img/pale-waiting.png)`}"
              ></div>
            </div>
            <p>Go!</p>
          </div>
          <div
            class="action-wrapper delay-entry delay-like-crazy log-in-button"
            @click="$router.push(`/survey/${sid}/analyze`)"
            type="warning"
          >
            <div class="profile-image-wrapper">
              <div
                v-if="profiles && profiles.length"
                class="avatar"
                :style="{backgroundImage: `url(${profiles[profiles.length - 1].fields.avatar.fields.file.url})`}"
              ></div>
              <div
                v-else
                class="avatar"
                :style="{backgroundImage: `url(${publicPath}/img/arabica-1.png)`}"
              ></div>
            </div>
            <p>Analizar</p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import AuthService from 'Core/src/auth/authService'

Vue.use(AuthService)
Vue.prototype.$eventHub = new Vue()

export default {
  name: 'Admin',

  data () {
    return {
      publicPath: process.env.VUE_APP_BASE_URL,
      sid: this.$store.state.admin.sid
    }
  },

  components: {
    Icons: () => import('Components/base/Icons'),
    SensataSplash: () => import('Components/base/SensataSplash')
  },

  computed: {
    allMongoDashKeys () {
      let set1 = Object.keys(this.mongoDashList)
      let set2 = Object.keys(this.mongoDBChartsList)
      let all = [...new Set([...set1 ,...set2])]
      return all
    },
    profiles () {
      return this.$store.state.testResults.profiles
    },
    username () {
      return this.$store.state.user.auth0.name || 'Stranger'
    },
    user () {
      return this.$store.state.user.auth0
    },
    loggedIn () {
      return this.$store.state.user.loggedIn
    },
    mongoDashList () {
      const namespace = process.env.VUE_APP_NAMESPACE
      if (this.user && this.user[namespace] && this.user[namespace].mongoDash) {
        return this.user[namespace].mongoDash
      }
    },
    mongoDBChartsList () {
      const namespace = process.env.VUE_APP_NAMESPACE
      if (this.user && this.user[namespace] && this.user[namespace].mongoDBCharts) {
        return this.user[namespace].mongoDBCharts
      }
    },
    sidList () {
      const namespace = process.env.VUE_APP_NAMESPACE
      if (this.user && this.user[namespace] && this.user[namespace].sid) {
        return this.user[namespace].sid
      }
    }
  },

  methods: {
    getSurveyName (sid) {
      if (!this.$store.state.admin.sidList[sid]) {
        this.$store.dispatch('ADMIN_LOAD_SID', { surveyId: sid})
      }
      if (this.$store.state.admin.sidList[sid]) {
        return this.$store.state.admin.sidList[sid].surveyName
      }
      return ''
    },
    clearSelectedSurvey () {
      this.$store.commit('ADMIN_SET_SID', { surveyId: null })
      this.sid = null
    },
    goToAdmin () {
      this.$router.push('/admin')
    },
    logIn () {
      localStorage.setItem('redirect_to_url', this.$route.fullPath)
      this.$auth.login()
    },
    logOut () {
      localStorage.setItem('redirect_to_url', this.$route.fullPath)
      this.$auth.logout()
    }
  },

  mounted () {
    /*
     * Authentication stuff: this is NOT POLISHED, it's a WIP
     */
    setTimeout(() => {
      if (!this.loggedIn) {
        this.$auth.silentLogin()
      }
    }, 1)

    /*
     * If user is not logged in, redirect
     */
    if (!this.loggedIn) {
      localStorage.removeItem('redirect_to_url')
      this.$router.push('/login')
    }

    if (!this.profiles) {
      if (this.$store.state.survey.testResults) {
        this.$store.dispatch('LOAD_TEST_RESULTS', { testResultsId: this.$store.state.survey.testResults.sys.id })
      }
    }
  },

  watch: {
    sid (newSID) {
      this.$store.commit('SET_TEST_RESULTS_DATA', { data: {} })
      this.$store.commit('ADMIN_SET_SID', { surveyId: newSID })
      this.$store.dispatch('LOAD_NEW_SURVEY', { surveyId: newSID })
    }
  }

}
</script>

<style lang="scss">
.sid-selector {
  .el-select-dropdown__item.selected {
    color: $color-emphasis;
  }
  .el-select {
    width: 90vw;
    @include breakpoint($tablet) {
      width: 400px;
      transform: scale(1.3);
    }
  }
  .el-select-dropdown__item {
    @include breakpoint($tablet) {
      font-size: 17px !important;
      height: 40px !important;
    }
  }
}
</style>
<style scoped lang="scss">
.user-section {
  margin-top: 0;
  h5 {
    font-weight: normal;
    margin: 0;
    text-align: left;
    font-size: 0.8em;
  }
}
.selected-survey-header {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  border-bottom: 1px solid rgba($color-wrapper-emphasis, 0.3);
  margin-bottom: 2em;
}
.clear-selected-survey-wrapper {
  &:hover {
    cursor: pointer;
  }
}
.desktop-view {
  min-height: 100vh;
  min-width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.sensata-splash-wrapper {
  max-width: 12em;
  top: 0;
  left: 0;
  margin-top: 2em;
  margin-bottom: 2em;
  @include breakpoint($tablet) {
    max-width: 8em;
  }
  @include breakpoint($desktop) {
    max-width: 4em;
    position: fixed;
    margin-left: 1em;
    margin-top: 1em;
    margin-bottom: 1em;
  }
  @include breakpoint($fullhd) {
    max-width: 6em;
  }
  &:hover {
    cursor: pointer;
  }
}

.log-out-button {
  bottom: 2em;
  left: 2em;
  margin-top: 1em;

  @include breakpoint($desktop) {
    position: fixed;
    margin-top: 0;
  }
}

.admin-content-wrapper {
  padding: 2em 1em;
  width: calc(100vw - 1em);
  right: 0;

  @include breakpoint($desktop) {
    width: calc(100vw - 8em);
    align-self: flex-end;
    min-height: calc(100vh - 4em);
    background: rgba($gray-light, 0.5);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  @include breakpoint($fullhd) {
    width: calc(100vw - 10em);
  }
}
section {
  margin-top: 1em;
}

.profile-image-wrapper,
.download-data-button {
  width: 45vw;
  height: 0;
  margin: 0.5em 1.5em;
  padding-bottom: 45vw;
  background: white;
  border-radius: 10em;
  @include breakpoint($tablet) {
    width: 8em;
    padding-bottom: 8em;
    min-width: 8em;
  }
  @include breakpoint($desktop) {
    width: 3.5em;
    padding-bottom: 3.5em;
    min-width: 3.5em;
  }

  @include breakpoint($fullhd) {
    width: 6em;
    padding-bottom: 6em;
  }
  .avatar {
    width: 100%;
    height: 0;
    padding-bottom: 75%;
    background-size: cover;
    background-position: top center;
  }
  &:hover {
    cursor: pointer;
  }
}

.actions-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-around;
  padding: 1em 0;
  align-items: flex-start;
  @include breakpoint($tablet) {
    width: 50%;
    float: left;
  }
}
.action-wrapper {
  background: rgba($gray-light, 0.6);
  border-radius: 10px;
  padding: 1em 0;
  transition: background-color 0.2s ease-in-out, transform 0.2s ease-in-out;
  margin-bottom: 1em;
  &:hover {
    cursor: pointer;
    background: rgba($color-wrapper-emphasis, 0.05);
    transform: scale(1.03);
  }
  p {
    font-size: 1.1em;
    @include breakpoint($tablet) {
      font-size: 0.8em;
    }
  }
}

.download-data-button {

}

</style>